import { Component, ElementRef, ViewContainerRef, Renderer2, Injector, ChangeDetectionStrategy, QueryList, ValueProvider, ContentChild } from '@angular/core';
import { ComponentBase, ComponentMixins, IComponentBase, applyMixins, PropertyCollectionInfo, setValue } from '@syncfusion/ej2-angular-base';
import { Accordion } from '@syncfusion/ej2-navigations';
import { Template } from '@syncfusion/ej2-angular-base';
import { AccordionItemsDirective } from './items.directive';

export const /** @type {?} */ inputs: string[] = ['animation','dataSource','enableHtmlSanitizer','enablePersistence','enableRtl','expandMode','expandedIndices','headerTemplate','height','itemTemplate','items','locale','width'];
export const /** @type {?} */ outputs: string[] = ['clicked','created','destroyed','expanded','expanding','expandedIndicesChange'];
export const /** @type {?} */ twoWays: string[] = ['expandedIndices'];
/**
 * Represents the Angular Accordion Component.
 * ```html
 * <ejs-accordion></ejs-accordion>
 * ```
 */
@ComponentMixins([ComponentBase])
export class AccordionComponent extends Accordion implements IComponentBase {
public containerContext : any;
public tagObjects: any;
public childItems: QueryList<AccordionItemsDirective>;
public tags: string[] = ['items'];
public expandedIndicesChange: any;
/**
 * Specifies the header title template option for accordion items.
 * \@default null
 */
@Template()
    public headerTemplate: any;
/**
 * Specifies the template option for accordion items.
 * \@default null
 */
@Template()
    public itemTemplate: any;
/**
 * @param {?} ngEle
 * @param {?} srenderer
 * @param {?} viewContainerRef
 * @param {?} injector
 */
constructor(private ngEle: ElementRef,
private srenderer: Renderer2,
private viewContainerRef:ViewContainerRef,
private injector: Injector) {
        super();
        this.element = this.ngEle.nativeElement;
        this.injectedModules = this.injectedModules || [];

        this.registerEvents(outputs);
        this.addTwoWay.call(this, twoWays);
        setValue('currentInstance', this, this.viewContainerRef);
        this.containerContext  = new ComponentBase();
    }
/**
 * @return {?}
 */
public ngOnInit() {
        this.containerContext.ngOnInit(this);
    }
/**
 * @return {?}
 */
public ngAfterViewInit(): void {
        this.containerContext.ngAfterViewInit(this);
    }
/**
 * @return {?}
 */
public ngOnDestroy(): void {
        this.containerContext.ngOnDestroy(this);
    }
/**
 * @return {?}
 */
public ngAfterContentChecked(): void {
        this.tagObjects[0].instance = this.childItems;
        this.containerContext.ngAfterContentChecked(this);
    }
public registerEvents: (eventList: string[]) => void;
public addTwoWay: (propList: string[]) => void;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ejs-accordion',
    inputs: inputs,
    outputs: outputs,
    template: `<ng-content select='div'></ng-content>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    queries: {
        childItems: new ContentChild(AccordionItemsDirective)
    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
{type: ViewContainerRef, },
{type: Injector, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'headerTemplate': [{ type: ContentChild, args: ['headerTemplate', ] },],
'itemTemplate': [{ type: ContentChild, args: ['itemTemplate', ] },],
};
}

function AccordionComponent_tsickle_Closure_declarations() {
/** @type {?} */
AccordionComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AccordionComponent.ctorParameters;
/** @type {?} */
AccordionComponent.propDecorators;
/** @type {?} */
AccordionComponent.prototype.containerContext;
/** @type {?} */
AccordionComponent.prototype.tagObjects;
/** @type {?} */
AccordionComponent.prototype.childItems;
/** @type {?} */
AccordionComponent.prototype.tags;
/** @type {?} */
AccordionComponent.prototype.expandedIndicesChange;
/**
 * Specifies the header title template option for accordion items.
 * \@default null
 * @type {?}
 */
AccordionComponent.prototype.headerTemplate;
/**
 * Specifies the template option for accordion items.
 * \@default null
 * @type {?}
 */
AccordionComponent.prototype.itemTemplate;
/** @type {?} */
AccordionComponent.prototype.registerEvents;
/** @type {?} */
AccordionComponent.prototype.addTwoWay;
/** @type {?} */
AccordionComponent.prototype.ngEle;
/** @type {?} */
AccordionComponent.prototype.srenderer;
/** @type {?} */
AccordionComponent.prototype.viewContainerRef;
/** @type {?} */
AccordionComponent.prototype.injector;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
